class NotFoundError extends Error {
    constructor(cause?: Error) {
        super("El recurso no ha sido encontrado o ha devuelto un estado 404", {
            cause,
        });
    }
}

export { NotFoundError };
